module.exports = require("./sk-SK");